import { useState } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { IoArrowForward } from "react-icons/io5";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import axios from "axios";
import { useCfStore } from "@/components/CfTurnstile";
import { addToDataLayer, addEnhancedToDataLayer } from "@/utils/addToDataLayer";
import FormSubmissionMessage from "../FormSubmissionMessage";

const AppraisalForm = ({ page = "", event = "Sell" }) => {
  const { token, reset } = useCfStore();
  const [itemToSell, setItemToSell] = useState("");
  const [submitMessage, setSubmitMessage] = useState({
    text: "",
    phoneLink: "",
  });

  const [success, setSuccess] = useState("");
  const [fail, setFail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    sellItem: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    if (!token) {
      window.alert("Checking for humans. Please try again in a minute.");
      setSubmitting(false);
      return;
    }

    await axios
      .post("/api/hubspot", { formData })
      .then(() => null)
      .catch(() => null);

    await axios
      .post("/api/submit-form", {
        fields: [
          { key: "First Name", value: formData?.firstName },
          { key: "Email", value: formData?.email },
          { key: "Phone", value: formData?.phone },
          { key: "Sell Item", value: formData?.sellItem },
          { key: "Message", value: formData?.message },
        ],
        page,
        firstName: formData?.firstName,
        email: formData?.email,
        sellItem: formData?.sellItem,
        event,
        recaptchaToken: token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setSubmitMessage({
            text: "Thank you for your inquiry. We will get back to you soon over an email or via a call. If you need assistance with anything else,",
            phoneLink: "(212) 913-9141",
          });
          setSuccess(true);
          addEnhancedToDataLayer(formData?.email);
          setFormData({
            firstName: "",
            email: "",
            phone: "",
            sellItem: "",
            message: "",
          });
        } else {
          setSubmitMessage({
            text: "Submisison unsuccessful. Please try again",
            phoneLink: "",
          });
          setFail(true);
        }
      })
      .catch((e) => {
        setSubmitMessage({
          text: "Submisison unsuccessful. Please try again",
          phoneLink: "",
        });
        setFail(true);
        console.log(e);
      })
      .finally(() => {
        setSubmitting(false);
        reset();
      });
  };

  return (
    <Form onSubmit={handleSubmit}>
      {submitMessage?.text && (
        <FormSubmissionMessage
          fail={fail}
          success={success}
          submitMessage={submitMessage}
        />
      )}
      {!submitMessage?.text && (
        <>
          <Row className="mb-md-3">
            <Col xs={12} md={6}>
              <FloatingLabel
                controlId="floatingInputName"
                label="Full name"
                className={` mb-3 mb-md-0 ${s.input}`}
              >
                <Form.Control
                  type="text"
                  placeholder="Full name"
                  value={formData?.firstName}
                  required={true}
                  onChange={(e) => {
                    setFormData({ ...formData, firstName: e.target.value });
                  }}
                  className="mb-3 mb-md-0"
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} md={6}>
              <FloatingLabel
                controlId="floatingInputPhone"
                label="Phone number"
                className={` mb-3 mb-md-0`}
              >
                <Form.Control
                  type="tel"
                  placeholder="Phone number"
                  required={true}
                  value={formData?.phone}
                  minLength="8"
                  maxLength="12"
                  onChange={(e) => {
                    setFormData({ ...formData, phone: e.target.value });
                  }}
                />
              </FloatingLabel>
            </Col>
          </Row>
          <Row className="mb-md-3">
            <Col xs={12} md={6}>
              <FloatingLabel
                controlId="floatingInputEmail"
                label="Email"
                className={` mb-3 mb-md-0`}
              >
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={formData?.email}
                  required={true}
                  onChange={(e) => {
                    setFormData({ ...formData, email: e.target.value });
                  }}
                />
              </FloatingLabel>
            </Col>
            <Col xs={12} md={6}>
              <FloatingLabel
                controlId="floatingSelect"
                label="Select item to sell"
                className={` mb-3 mb-md-0 ${
                  itemToSell === "" ? s.no_select_input : ""
                }`}
                // onChange={(e) => { setItemToSell(e.target.value) }}
                value={itemToSell}
                required={true}
                onChange={(e) => {
                  setItemToSell(e.target.value);
                  setFormData({ ...formData, sellItem: e.target.value });
                }}
              >
                <Form.Select aria-label="Select item to sell">
                  <option value=""></option>
                  <option value="Luxury Watches">Luxury Watches</option>
                  <option value="Jewelry">Jewelry</option>
                  <option value="Diamonds">Diamonds</option>
                  <option value="Gold">Gold</option>
                  <option value="Gold Coins">Gold Coins</option>
                  <option value="Platinum">Platinum</option>
                  <option value="Silver">Silver</option>
                  <option value="Designer Bag">Designer Bag</option>
                  <option value="Other Item">Other Item</option>
                </Form.Select>
              </FloatingLabel>
            </Col>
          </Row>
          <FloatingLabel
            controlId="floatingInputItems"
            label="Message & items descriptions"
            className={` mb-3`}
          >
            <Form.Control
              as="textarea"
              placeholder="Message & items descriptions"
              style={{ height: "100px" }}
              value={formData?.message}
              onChange={(e) => {
                setFormData({ ...formData, message: e.target.value });
              }}
            />
          </FloatingLabel>
          <button
            type="submit"
            disabled={submitting}
            className={`btn btn-primary w-100 justify-content-center ${secondaryFont}`}
          >
            Get an offer now{" "}
            <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
          </button>
        </>
      )}
    </Form>
  );
};

export default AppraisalForm;
